import React, { useEffect, useRef, useState, useContext } from 'react'
import "./style.css"
import { NavLink, Link, useLocation } from 'react-router-dom'
import { AuthContext } from "../../context/auth.js"
import { toAbsoluteUrl } from '../../utils/assetHelper'
import { checkIsActive } from '../../utils/routeHelper'



const Index = () => {
  const { setSignInModal, setSignUpModal, user, isLoggedIn, setLogOutModal, width, cartData } = useContext(AuthContext)
  const { pathname } = useLocation()
  const dropdownRef = useRef(null)
  const toolsDropdownRef = useRef(null)
  const technologiesDropdownRef = useRef(null)
  const moreDropdownRef = useRef(null)
  const [dropdownOpen, setDropDownOpen] = useState({ name: '', open: false })
  const [hamburgerOpen, setHamburgerOpen] = useState(false)
  const [quantity, setQuantity] = useState(1)

  useEffect(() => {
    if (cartData && cartData?.items?.length > 0) {
      setQuantity(cartData?.items?.reduce((acc, curr) => acc + curr?.quantity, 0))
    }
  }, [cartData])


useEffect(() => {
    if (hamburgerOpen && width < 1360) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
}, [hamburgerOpen, width])


  useEffect(() => {
    if (width > 1200) {
      const handleClickOutside = (event) => {
        if (
          (dropdownOpen.name === 'product' &&
          toolsDropdownRef.current &&
          !toolsDropdownRef.current.contains(event.target)) ||
          (dropdownOpen.name === 'technologies' &&
          technologiesDropdownRef.current &&
          !technologiesDropdownRef.current.contains(event.target)) ||
          (dropdownOpen.name === 'more' &&
          moreDropdownRef.current &&
          !moreDropdownRef.current.contains(event.target)) || 
          (dropdownOpen.name === 'profile' && 
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target))
      ) {
        setDropDownOpen({ name: '', open: false });
      }
      };

      document.addEventListener('mousedown', handleClickOutside);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [width, dropdownOpen]);


  return (
    <header id="nav-menu" aria-label="navigation bar">
      <div class="nav-container" style={{ boxShadow: pathname.includes('ssb') || pathname.includes('dsb-hr') || pathname.includes('dsb-nh') ? 'none' : '' }}>
        <div class="nav-start">
          <Link class="logo" to="/">
            <img src={toAbsoluteUrl("/media/logowithtext.png")} width="156" height="32" alt="Inc Logo" />
          </Link>
          <nav class={`menu ${hamburgerOpen ? 'show' : ''}`}>
            <ul class="menu-bar">
              <li><NavLink className="nav-link" to="/">Home</NavLink></li>
              <li>
                <button class="nav-link dropdown-btn" style={{ color: pathname.includes('product') && !pathname.includes('product-search') ? 'var(--primary-color)' : '', fontWeight: dropdownOpen.name === 'product' && dropdownOpen.open ? '700' : '500' }} data-dropdown="dropdown1" aria-haspopup="true" aria-expanded="false" aria-label="product"
                  onClick={() => {
                    if (dropdownOpen.name === 'product') {
                      setDropDownOpen({
                        name: '',
                        open: false
                      })
                    } else {
                      setDropDownOpen({
                        name: 'product',
                        open: true
                      })
                    }
                  }}
                >
                  Tools
                  {dropdownOpen.name === 'product' && dropdownOpen.open ? <i class="bx bx-chevron-up" aria-hidden="true"></i> : <i class="bx bx-chevron-down" aria-hidden="true"></i>}
                </button>
                <div id="dropdown1" className={`dropdown ${dropdownOpen.name === 'product' && dropdownOpen.open ? 'active' : ''}`} ref={toolsDropdownRef}>
                  <ul role="menu">
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/product/pathways">Interactive Molecular Pathways</NavLink>
                    </li>
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/product/alexa-fluor-secondary">Identifyn® SRM Alexa Fluor™ Secondary Flourescence</NavLink>
                    </li>
                  </ul>
                </div>
              </li>
              <li className='hide-nav-link'>
                <button class="nav-link dropdown-btn" style={{ color: pathname.includes('technologies') ? 'var(--primary-color)' : '', fontWeight: dropdownOpen.name === 'technologies' && dropdownOpen.open ? '700' : '500' }} data-dropdown="dropdown2" aria-haspopup="true" aria-expanded="false" aria-label="technologies"
                  onClick={() => {
                    if (dropdownOpen.name === 'technologies') {
                      setDropDownOpen({
                        name: '',
                        open: false
                      })
                    } else {
                      setDropDownOpen({
                        name: 'technologies',
                        open: true
                      })
                    }
                  }}
                >
                  Technologies
                  {dropdownOpen.name === 'technologies' && dropdownOpen.open ? <i class="bx bx-chevron-up" aria-hidden="true"></i> : <i class="bx bx-chevron-down" aria-hidden="true"></i>}
                </button>
                <div id="dropdown2" className={`dropdown ${dropdownOpen.name === 'technologies' && dropdownOpen.open ? 'active' : ''}`} ref={technologiesDropdownRef}>
                  <ul role="menu">
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/technologies/zeiss">Zeiss™</NavLink>
                    </li>
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/technologies/bruker">Bruker™ - Vutara VXL</NavLink>
                    </li>
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/technologies/azure">Azure Biosystems™</NavLink>
                    </li>
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/technologies/acquifer">Acquifer™</NavLink>
                    </li>
                  </ul>
                </div>
              </li>
              <li><NavLink className="nav-link" to="/microscopy-methods">Identifyn® Standards</NavLink></li>
              <li className='hide-nav-link show-nav-link'><NavLink className="nav-link" to="/services">Services</NavLink></li>
              <li className='hide-nav-link show-nav-link'><NavLink className="nav-link" to="/assay-development">Assays</NavLink></li>
              <li className='hide-nav-link'><NavLink className="nav-link" to="/about">About Us</NavLink></li>
              <li><NavLink className="nav-link" to="/product-search">Product Search</NavLink></li>
              <li><NavLink className="nav-link" to="/product-release" style={{ color: '#3F1BD0' }}>Shop New Reagents</NavLink></li>
              <li className='hide-nav-link'><NavLink className="nav-link" to="/contact">Contact Us</NavLink></li>
              <li className='more-nav-link'>
                <button class="nav-link dropdown-btn" style={{ fontWeight: dropdownOpen.name === 'more' && dropdownOpen.open ? '700' : '500' }} data-dropdown="dropdown4" aria-haspopup="true" aria-expanded="false" aria-label="more"
                  onClick={() => {
                    if (dropdownOpen.name === 'more') {
                      setDropDownOpen({
                        name: '',
                        open: false
                      })
                    } else {
                      setDropDownOpen({
                        name: 'more',
                        open: true
                      })
                    }
                  }}
                >
                  More
                  {dropdownOpen.name === 'more' && dropdownOpen.open ? <i class="bx bx-chevron-up" aria-hidden="true"></i> : <i class="bx bx-chevron-down" aria-hidden="true"></i>}
                </button>
                <div id="dropdown4" className={`dropdown ${dropdownOpen.name === 'more' && dropdownOpen.open ? 'active' : ''}`} ref={moreDropdownRef}>
                  <ul role="menu">
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/technologies/zeiss">Zeiss™</NavLink>
                    </li>
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/technologies/bruker">Bruker™ - Vutara VXL</NavLink>
                    </li>
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/technologies/azure">Azure Biosystems™</NavLink>
                    </li>
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/technologies/acquifer">Acquifer™</NavLink>
                    </li>
                    {width < 1500 && 
                    <>
                    <li role="menuitem">
                      <NavLink className="dropdown-link" to="/services">Services</NavLink>
                    </li>
                     <li role="menuitem">
                      <NavLink className="dropdown-link" to="/assay-development">Assays</NavLink>
                    </li>
                    </>
                    }
                     <li role="menuitem">
                      <NavLink className="dropdown-link" to="/about">About Us</NavLink>
                    </li>
                     <li role="menuitem">
                      <NavLink className="dropdown-link" to="/contact">Contact Us</NavLink>
                    </li>
                  </ul>
                </div>
              </li>
              {/* {width < 1360 && user && isLoggedIn && <li><NavLink className="nav-link cart-btn" to={"/cart"}>
                Cart
                <i class="bx bx-cart" aria-hidden="true" style={{ fontSize: '24px', color: '#28272E' }}></i>
                {cartData?.items && cartData?.items?.length > 0 && <span>{quantity}</span>}
              </NavLink>
              </li>
              } */}
              <div className="auth-container">
                {user && isLoggedIn ?
                  <>
                    <div class="nav-link avatar" style={{ color: pathname.includes('profile') ? 'var(--primary-color)' : '', cursor: 'pointer' }} data-dropdown="dropdown1" aria-haspopup="true" aria-expanded="false" aria-label="product"
                      onClick={() => {
                        if (dropdownOpen.name === 'profile') {
                          setDropDownOpen({
                            name: '',
                            open: false
                          })
                        } else {
                          setDropDownOpen({
                            name: 'profile',
                            open: true
                          })
                        }
                      }}
                    >
                      {user?.customer?.avatar ?
                        <img src={user?.customer?.avatar} alt="product" className='avatar-img' style={{ border: dropdownOpen.name === 'profile' && dropdownOpen.open && '2px solid var(--primary-color)' }} />
                        :
                        <div className="custom-profile" style={{ border: dropdownOpen.name === 'profile' && dropdownOpen.open && '1px solid #F1EEFC' }}>{user?.customer?.first_name[0]?.toUpperCase()}</div>
                      }
                      <span className='avatar-name'>{user?.customer?.first_name} {user.customer?.last_name}</span>
                      {dropdownOpen.name === 'profile' && dropdownOpen.open ? <i class="bx bx-chevron-up" aria-hidden="true"></i> : <i class="bx bx-chevron-down" aria-hidden="true"></i>}
                    </div>
                    <div id="dropdown3" className={`dropdown ${dropdownOpen.name === 'profile' && dropdownOpen.open ? 'active' : ''}`} ref={dropdownRef}>
                      <ul role="menu ">
                        <li role="menuitem">
                          <NavLink class="dropdown-link" to="/profile/account">Account</NavLink>
                        </li>
                        <li role="menuitem">
                          <NavLink className="dropdown-link" to="/profile/orders">Orders</NavLink>
                        </li>
                        <li role="menuitem">
                          <Link class="dropdown-link" to="/contact?support=Accout Support">Support</Link>
                        </li>
                        <li role="menuitem">
                          <button class="dropdown-link" style={{ fontSize: '1rem', color: 'var(--primary-color)' }} onClick={() => setLogOutModal(true)} >Sign Out</button>
                        </li>
                      </ul>
                    </div>
                  </>
                  : <>
                    {/* <Link class="nav-link cart-btn" to={"/cart"}>
                      Cart
                      <i class="fal fa-shopping-cart" aria-hidden="true" style={{ fontSize: '20px', color: '#28272E' }}></i>
                      {cartData?.items && cartData?.items?.length > 0 && <span>{quantity}</span>}
                    </Link> */}
                    <button class="btn btn-transparent" style={{ marginBottom: '10px' }} onClick={() => setSignInModal(true)}>Sign In</button>
                    <button class="btn btn-primary" onClick={() => setSignUpModal(true)}>Sign Up</button>
                  </>
                }
              </div>
            </ul>
          </nav>
        </div>

        <div class="nav-end">
          <div class="right-container">
            {/* <form class="search" role="search">
            <input type="search" name="search" placeholder="Search" />
            <i class="bx bx-search" aria-hidden="true"></i>
          </form>
          <a href="#profile">
            <img src="https://github.com/Evavic44/responsive-navbar-with-dropdown/blob/main/assets/images/user.jpg?raw=true" width="30" height="30" alt="user image" />
          </a> */}
            {user && isLoggedIn ? <>
              <div class="nav-link avatar" style={{ color: pathname.includes('profile') ? 'var(--primary-color)' : '', cursor: 'pointer' }} data-dropdown="dropdown1" aria-haspopup="true" aria-expanded="false" aria-label="product"
                onClick={() => {
                  if (dropdownOpen.name === 'profile') {
                    setDropDownOpen({
                      name: '',
                      open: false
                    })
                  } else {
                    setDropDownOpen({
                      name: 'profile',
                      open: true
                    })
                  }
                }}
              >
                {user?.customer?.avatar ?
                  <img src={user?.customer?.avatar} alt="product" className='avatar-img' style={{ border: dropdownOpen.name === 'profile' && dropdownOpen.open && '2px solid var(--primary-color)' }} />
                  :
                  <div className="custom-profile" style={{ border: dropdownOpen.name === 'profile' && dropdownOpen.open && '1px solid #F1EEFC' }}>{user?.customer?.first_name[0]?.toUpperCase()}</div>
                }
                <span className='avatar-name'>{user.customer?.first_name} {user.customer?.last_name[0]?.toUpperCase()}</span>
                {dropdownOpen.name === 'profile' && dropdownOpen.open ? <i class="bx bx-chevron-up" aria-hidden="true"></i> : <i class="bx bx-chevron-down" aria-hidden="true"></i>}
              </div>
              <div id="dropdown3" className={`dropdown ${dropdownOpen.name === 'profile' && dropdownOpen.open ? 'active' : ''}`} ref={dropdownRef}>
                <ul role="menu ">
                  <li role="menuitem">
                    <NavLink className="dropdown-link" to="/profile/account">Account</NavLink>
                  </li>
                  <li role="menuitem">
                    <NavLink className="dropdown-link" to="/profile/orders">Orders</NavLink>
                  </li>
                  <li role="menuitem">
                    <Link class="dropdown-link" to="/contact?support=Accout Support">Support</Link>
                  </li>
                  <li role="menuitem">
                    <button class="dropdown-link" style={{ color: 'var(--primary-color)' }} onClick={() => setLogOutModal(true)} >Sign Out</button>
                  </li>
                </ul>
              </div>
            </>
              :
              <>
                <button class="btn btn-transparent auth-btn" onClick={() => setSignInModal(true)}>Sign In</button>
                <button class="btn btn-primary auth-btn" onClick={() => setSignUpModal(true)}>Sign Up</button>
              </>
            }
            {/* <Link class="nav-link dropdown-btn cart-btn" to={"/cart"}>
              <i class="fal fa-shopping-cart" aria-hidden="true" style={{ fontSize: '20px', color: '#28272E' }}></i>
              {cartData?.items && cartData?.items?.length > 0 && <span>{quantity}</span>}
            </Link> */}
          </div>

          <button id="hamburger" aria-label="hamburger" aria-haspopup="true" aria-expanded="false"
            onClick={() => {
              setHamburgerOpen(!hamburgerOpen)
            }}
          >
            <i class="bx bx-menu" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </header>
  )
}

export default Index